import React from 'react'
import SelectInput from "components/inputs/selectInput"
import { useTranslation } from "react-i18next"
import TextInput from 'components/inputs/textInput'
import Collapse from 'components/collapse/Collapse'
import { ReactComponent as FilterIcon } from 'assets/icons/filter.svg'
import InputGroup from '@/components/inputs/InputGroup'
import { HistoryEntryType } from 'types'

interface HistoryFilterProps {
    filterDocumentType: string,
    setFilterDocumentType: (str: string) => void,
    filterDocumentId: string,
    setFilterDocumentId: (str: string) => void,
    filterActionType: string,
    setFilterActionType: (str: string) => void,
    isLoading?: boolean
}

const HistoryFilter: React.FC<HistoryFilterProps> = ({
    filterDocumentType,
    setFilterDocumentType,
    filterDocumentId,
    setFilterDocumentId,
    filterActionType,
    setFilterActionType,
    isLoading
}) => {

    const { t } = useTranslation()

    const handleFilterDocumentTypeChange = (str: string) => {
        setFilterDocumentType(str)
    }

    const handleFilterDocumentIdChange = (str: string) => {
        setFilterDocumentId(str)
    }

    const handleFilterActionTypeChange = (str: string) => {
        setFilterActionType(str)
    }

    return (
        <div className="flex flex-col gap-y-4">
            <Collapse textOpen={t(`labelHideFilters`)} textClosed={t(`labelShowFilters`)} icon={<FilterIcon />}>
                <InputGroup forcedColumns={true}>
                    <SelectInput 
                        ignore={true} 
                        label={t('labelFilterDocumentType')} 
                        value={filterDocumentType} 
                        onChange={(e) => handleFilterDocumentTypeChange(e.target.value)} 
                        disabled={isLoading}
                    >
                        <option value="">{t('all')}</option>
                        <option value="storage">{t('storage')}</option>
                        <option value="category">{t('category')}</option>
                        <option value="location">{t('location')}</option>
                        <option value="product">{t('product')}</option>
                        <option value="customer">{t('customer')}</option>
                        <option value="supplier">{t('supplier')}</option>
                        <option value="transaction">{t('transaction')}</option>
                        <option value="action">{t('action')}</option>
                    </SelectInput>
                    <TextInput 
                        ignore={true} 
                        label={t('labelFilterDocumentId')} 
                        value={filterDocumentId} 
                        onChange={(e) => handleFilterDocumentIdChange(e.target.value)} 
                        disabled={isLoading} 
                    />
                    <SelectInput 
                        ignore={true} 
                        label={t('labelFilterActionType')} 
                        value={filterActionType} 
                        onChange={(e) => handleFilterActionTypeChange(e.target.value)} 
                        disabled={isLoading}
                    >
                        <option value="">{t('all')}</option>
                        <option value={HistoryEntryType.CREATE}>{t('historyActionCreate')}</option>
                        <option value={HistoryEntryType.MODIFY}>{t('historyActionModify')}</option>
                        <option value={HistoryEntryType.DELETE}>{t('historyActionDelete')}</option>
                        <option value={HistoryEntryType.RESTORE}>{t('historyActionRestore')}</option>
                    </SelectInput>
                </InputGroup>
            </Collapse>
        </div>
    )
}

export default HistoryFilter
